import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ProductCards from "../../components/ProductCards/index";
import Footer from "../../components/Footer/index";

import motoImage from "../../assets/ProductImages/Premios-Avanti-PNG-moto.png";
import carroImage from "../../assets/ProductImages/Premios-Avanti-PNG-carro.png";
import apartamentoImage from "../../assets/ProductImages/Premios-Avanti-PNG-Apartamento.png";
import smartphoneImage from "../../assets/ProductImages/Premios-Avanti-PNG-celular.png";
import TVImage from "../../assets/ProductImages/Premios-Avanti-PNG-TV.png";
import cardBackgroundImage from "../../assets/background.png";

const mockProducts = [
  {
    products: [
      {
        ImageUrl__c: TVImage,
        Name: "SMART TV 58”",
        awarded: 4,
      },
    ],
    winners: [],
    Date: "2025-02-22T00:00:00.000Z",
    mockedDate: "30/04/2025",
    backgroundImageUrl__c: null,
  },
  {
    products: [
      {
        ImageUrl__c: motoImage,
        Name: "Moto 0KM",
        awarded: 1,
        Disclaimer__c:
          "O prêmio será entregue em certificados de barras de ouro.",
      },
    ],
    winners: [],
    Date: "2025-02-23T00:00:00.000Z",
    mockedDate: "30/06/2025",
    backgroundImageUrl__c: null,
  },
  {
    products: [
      {
        ImageUrl__c: smartphoneImage,
        Name: "Smartphone",
        awarded: 4,
      },
    ],
    winners: [],
    Date: "2025-02-24T00:00:00.000Z",
    mockedDate: "31/08/2025",
    backgroundImageUrl__c: null,
  },
  {
    products: [
      {
        ImageUrl__c: carroImage,
        Name: "Carro 0KM",
        awarded: 1,
        Disclaimer__c:
          "O prêmio será entregue em certificados de barras de ouro.",
      },
    ],
    winners: null,
    Date: "2025-02-24T00:00:00.000Z",
    mockedDate: "31/10/2025",
    backgroundImageUrl__c: null,
  },
  {
    products: [
      {
        ImageUrl__c: TVImage,
        Name: "SMART TV 58”",
        awarded: 4,
      },
      {
        ImageUrl__c: smartphoneImage,
        Name: "Smartphone",
        awarded: 4,
      },
    ],
    winners: null,
    Date: "2025-02-24T00:00:00.000Z",
    mockedDate: "31/12/2025",
    backgroundImageUrl__c: null,
  },
  {
    products: [
      {
        ImageUrl__c: TVImage,
        Name: "SMART TV 58”",
        awarded: 2,
      },
      {
        ImageUrl__c: apartamentoImage,
        Name: "APARTAMENTO",
        awarded: 1,
        Disclaimer__c:
          "O prêmio será entregue em certificados de barras de ouro.",
      },
      {
        ImageUrl__c: smartphoneImage,
        Name: "Smartphone",
        awarded: 2,
      },
    ],
    winners: null,
    Date: "2025-02-24T00:00:00.000Z",
    mockedDate: "10/02/2026",
    backgroundImageUrl__c: cardBackgroundImage,
  },
];

const WinnersTab = (props) => {
  const { rafflesWinnersData } = useSelector((state) => state.raffles);
  
  useEffect(() => {
    mockProducts.sort((a, b) => new Date(a.Date) - new Date(b.Date));
  }, []);

  return (
    <Container>
      <div className="Content">
        <ProductCards
          title="Ganhadores"
          subtitle="Confira aqui os sortudos da promoção"
          disclaimer="As imagens dos premios são meramente ilustrativas"
          data={rafflesWinnersData || []}
          onChangeTab={props?.onChangeTab}
          isWinnerScreen
        />
      </div>
      <Footer />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  height: 100%;

  .Content {
    width: 100vw;
    max-width: 1200px;
    margin: 88px 0 45px 0;

    @media (max-width: 768px) {
      margin: 45px 0 45px 0;
    }
  }
`;

export default WinnersTab;
